export default __webpack_public_path__ + "static/media/alba-playlist.bbd74545.jpg";